// extracted by mini-css-extract-plugin
module.exports = {"error":"Counter_error__2qSxH","counter":"Counter_counter__1rg1g"};